<template>
    <SOSlotBase :bg-white="true" :loading="isFetching">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar :page-title="'Kirim Pesan Blast WA'" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div class="p-x-20 p-y-16">
                <div class="p-d-20">
                    <SOInputRegular
                        :title="'Judul blast'"
                        :placeholder="'Cth: Promo Ramadhan'"
                        :validation="'alphanumeric'"
                        :required="true"
                        :value="payload.judul"
                        @input="
                            (v) => {
                                payload.judul = v;
                            }
                        "
                    />
                    <ErrorMessage :label="'Judul blast'" :validation="$v.payload.judul" />
                </div>

                <div class="p-d-20">
                    <div class="f-regular f-14 f-c-midgrey require">Pilih perangkat WA</div>
                    <div class="wa-device-list-container m-d-4">
                        <div
                            class="p-x-16 p-y-12 border-bottom"
                            v-for="device in waDevice"
                            :key="device.iddevice"
                            :class="{
                                'wa-device-selected': payload.iddevice.filter((v) => v === device.iddevice).length > 0,
                            }"
                        >
                            <div class="form-check form-check-inline">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="`device${device.iddevice}`"
                                    :value="`${device.iddevice}`"
                                    v-model="payload.iddevice"
                                />
                                <label class="form-check-label m-l-12" :for="`device${device.iddevice}`">
                                    <div class="f-semi f-14 f-c-black nomore" style="width: 250px">
                                        {{ device.nama }}
                                    </div>
                                    <div class="f-regular f-14 f-c-midgrey">
                                        {{ device.country_code + device.number }}
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="f-regular f-12 f-c-midgrey">
                        Semakin banyak perangkat akan menurunkan resiko blokir dari pihak WA.
                    </div>
                    <ErrorMessage :label="'Perangkat WA'" :validation="$v.payload.iddevice" />
                </div>

                <div class="p-d-20">
                    <div class="f-regular f-14 f-c-midgrey require">Template pesan</div>
                    <div class="wa-device-list-container m-d-4">
                        <div class="d-flex-between-center p-x-16 p-y-10" v-if="payload.namaTemplate.length > 0">
                            <div>
                                <div
                                    class="d-flex align-items-center"
                                    v-for="(namaTemplate, idx) in payload.namaTemplate"
                                    :key="`${idx}-template`"
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M1.33332 4.66699C1.33332 3.56242 2.22875 2.66699 3.33332 2.66699H12.6667C13.7712 2.66699 14.6667 3.56242 14.6667 4.66699V5.32331C14.6668 5.32981 14.6668 5.33629 14.6667 5.34278V11.3337C14.6667 12.4382 13.7712 13.3337 12.6667 13.3337H3.33332C2.22875 13.3337 1.33332 12.4382 1.33332 11.3337V5.34277C1.33323 5.33629 1.33323 5.32981 1.33332 5.32332V4.66699ZM2.66666 6.57934V11.3337C2.66666 11.7018 2.96513 12.0003 3.33332 12.0003H12.6667C13.0348 12.0003 13.3333 11.7018 13.3333 11.3337V6.57934L9.10939 9.39529C8.43759 9.84316 7.56239 9.84316 6.89059 9.39529L2.66666 6.57934ZM13.3333 4.97687V4.66699C13.3333 4.2988 13.0348 4.00033 12.6667 4.00033H3.33332C2.96513 4.00033 2.66666 4.2988 2.66666 4.66699V4.97687L7.63019 8.28589C7.85412 8.43518 8.14586 8.43518 8.36979 8.28589L13.3333 4.97687Z"
                                            fill="#C8D0DD"
                                        />
                                    </svg>
                                    <div class="f-regular f-16 f-c-black m-l-12">
                                        {{ namaTemplate }}
                                    </div>
                                </div>
                            </div>
                            <div @click="pilihTemplate">
                                <img src="@/assets/icons/edit-20.svg" alt="" />
                            </div>
                        </div>
                        <div class="p-x-16 p-y-10" v-else @click="pilihTemplate">
                            <div class="f-regular f-16 f-c-blue">Pilih template...</div>
                        </div>
                    </div>
                    <div class="f-regular f-12 f-c-midgrey">
                        Semakin banyak template akan menurunkan resiko blokir dari pihak WA.
                    </div>
                    <ErrorMessage :label="'Template'" :validation="$v.payload.idtemplate" />
                </div>

                <div class="p-d-20">
                    <SOInputNumber
                        :title="'Interval'"
                        :required="true"
                        :id="'interval'"
                        :suffix="'Detik'"
                        :default-value="parseInt(payload.interval)"
                        :min-value="parseInt('40')"
                        @input="
                            (v) => {
                                payload.interval = parseInt(v);
                            }
                        "
                    />
                    <ErrorMessage :label="'Interval'" :validation="$v.payload.interval" />
                    <div class="f-regular f-12 f-c-midgrey m-t-4">
                        Jarak waktu antara satu pesan yang dikirim. Disarankan 40 detik atau lebih.
                    </div>
                </div>

                <div class="p-d-20">
                    <div class="f-regular f-14 f-c-midgrey require">Target konsumen</div>
                    <div class="wa-device-list-container m-d-8">
                        <div
                            class="f-regular f-16 f-c-blue p-x-12 p-y-10"
                            v-if="totalCustomer === 0"
                            @click="pilihKonsumen"
                        >
                            Pilih konsumen...
                        </div>
                        <div class="d-flex-between-center" @click="pilihKonsumen" v-else>
                            <div class="f-regular f-16 f-c-blue p-x-12 p-y-10">
                                {{ totalCustomer }} Konsumen dipilih
                            </div>
                            <div class="p-x-12 p-y-10">
                                <img src="@/assets/icons/edit-20.svg" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="bg-grey rounded f-regular f-12 f-c-midgrey p-x-8 p-y-12" v-if="totalCustomer > 0">
                        <ul style="padding-left: 16px; margin: 0">
                            <li v-if="getKey !== ''"><b>Pencarian:</b> {{ getKey }}</li>
                            <li v-if="getFilterBy !== ''"><b>Filter konsumen berdasarkan:</b> {{ getFilterBy }}</li>
                            <li v-if="getTahun !== ''"><b>Tahun:</b> {{ getTahun }}</li>
                            <li v-if="getBulan !== ''"><b>Bulan:</b> {{ getBulan }}</li>
                            <li v-if="getPeriode !== ''"><b>Periode:</b> {{ getPeriode }}</li>
                            <li v-if="getFilterKolom"><b>Filter kolom:</b> {{ getFilterKolom }}</li>
                            <li v-if="getFilterLayanan !== ''"><b>Filter layanan:</b> {{ getFilterLayanan }}</li>
                            <li v-if="getJumlahLayanan > 0"><b>Jumlah layanan:</b> {{ getJumlahLayanan }} Layanan</li>
                            <li v-if="getJumlahDeposit > 0"><b>Jumlah deposit:</b> {{ getJumlahDeposit }} Deposit</li>
                            <li v-if="getJumlahOutlet > 0"><b>Jumlah outlet:</b> {{ getJumlahOutlet }} Outlet</li>
                        </ul>
                    </div>
                    <ErrorMessage :label="'Target Konsumen'" :validation="$v.totalCustomer" />
                </div>
                <div class="p-d-20">
                    <SOInputSelect
                        title="Lokasi Biaya Diakui di Outlet"
                        :required="true"
                        placeholder="Sena Laundry"
                        :options="listOutlet"
                        @option-selected="(v) => (payload.idoutlet = v)"
                        :selected="payload.idoutlet"
                    />
                    <ErrorMessage :label="'Outlet'" :validation="$v.payload.idoutlet" />
                    <div class="f-regular f-12 f-c-midgrey m-t-4">
                        Digunakan saat menggunakan M-Coin (jika anda sudah mengaktifkan integrasi M-Coin)
                    </div>
                </div>

                <SOButton
                    :text="'Konfirmasi'"
                    :loading="false"
                    :disable="false"
                    :full="true"
                    :primary="true"
                    @action="confirmBlast"
                />
            </div>
        </template>
    </SOSlotBase>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "./../store/state";
import { minLength, minValue, required } from "vuelidate/lib/validators";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputNumber from "@/so-components/global/input/SOInputNumber";
import SOButton from "@/so-components/global/ui/SOButton";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import conn from '@/store/utils/connection';

export default {
    name: "WABlastCreate",
    components: {
        SOSlotBase,
        SOLoadingPage,
        SOTitleBar,
        SOInputRegular,
        ErrorMessage,
        SOInputNumber,
        SOButton,
        SOInputSelect,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            waDevice: "waDevice",
            payload: "payloadCreateBlast",
            totalCustomer: "totalCustomer",
            blastType: "blastType",
            blastTypeId: "blastTypeId",
        }),
        getKey() {
            return this.payload.filter_customer.key;
        },
        getFilterBy() {
            return this.payload.filter_customer.filter_by;
        },
        getTahun() {
            if (!this.payload.filter_customer.filter_by === "tahun") {
                return "";
            }
            return this.payload.filter_customer.tahun;
        },
        getBulan() {
            if (this.payload.filter_customer.filter_by !== "bulan") {
                return "";
            }
            return this.payload.filter_customer.bulan === ""
                ? ""
                : this.$moment(this.payload.filter_customer.bulan, "YYYY-MM").format("MMMM YYYY");
        },
        getPeriode() {
            if (this.payload.filter_customer.filter_by !== "periode") {
                return "";
            }
            return this.payload.filter_customer.tanggal_awal === "" && this.payload.filter_customer.tanggal_akhir === ""
                ? ""
                : `${this.$moment(this.payload.filter_customer.tanggal_awal).format("DD MMM YYYY")}` +
                      " - " +
                      `${this.$moment(this.payload.filter_customer.tanggal_akhir).format("DD MMM YYYY")}`;
        },
        getFilterKolom() {
            return this.payload.filter_customer.filter_kolom
                ? this.payload.filter_customer.filter_kolom.replace(/_/g, " ")
                : "";
        },
        getFilterLayanan() {
            return this.payload.filter_customer.filter_layanan_by !== ""
                ? this.payload.filter_customer.filter_layanan_by.replace(/_/g, " ")
                : "";
        },
        getJumlahLayanan() {
            return this.payload.filter_customer.idlayanan_array.length;
        },
        getJumlahDeposit() {
            return this.payload.filter_customer.iddeposit_array.length;
        },
        getJumlahOutlet() {
            return this.payload.filter_customer.outlet_array.length;
        },
    },
    data() {
        return {
            listOutlet: [],
            jenis: null,
            idJenis: null,
        };
    },
    // data() {
    //     return {
    //         payload: {
    //             judul: "",
    //             iddevice: [],
    //             idtemplate: [],
    //             interval: "40",
    //             filter_customer: {
    //                 filter_by: "",
    //                 tahun: "",
    //                 bulan: "",
    //                 tanggal_awal: "",
    //                 tanggal_akhir: "",
    //                 filter_kolom: null,
    //                 filter_layanan_by: "",
    //                 idlayanan_array: [],
    //                 iddeposit_array: [],
    //                 outlet_array: [],
    //             }
    //         },
    //     }
    // },
    validations: {
        payload: {
            judul: {
                required,
                minLength: minLength(2),
            },
            iddevice: {
                required,
            },
            idtemplate: {
                required,
            },
            interval: {
                required,
                minValue: minValue(40),
            },
            idoutlet: {
                required,
            },
        },
        totalCustomer: {
            required,
            minValue: minValue(1),
        },
    },
    mounted() {
        this.getJenis();
        this.fetchWaDevice({ status: 1 });
        this.smartTrackingView('add_blast_whatsapp')
        this.getOutlet();
    },
    methods: {
        ...mapActions({
            fetchWaDevice: `${moduleName}/fetchWaDevice`,
            setPayloadCreateBlast: `${moduleName}/setPayloadCreateBlast`,
            createBlast: `${moduleName}/createBlast`,
            resetListHistory: `${moduleName}/resetListHistory`,
            setResponse: `${moduleName}/setResponse`,
            setFetching: `${moduleName}/setFetching`,
            resetPayload: `${moduleName}/resetPayloadCreateBlast`,
        }),
        back() {
            this.resetPayload();
            this.$router.back();
        },

        pilihTemplate() {
            this.$router.push({ name: "wa_blast.template.list", query: {
                jenis: this.blastType,
                idJenis: this.blastTypeId
            }});
        },
        pilihKonsumen() {
            this.$router.push({ name: "wa_blast.pilih_konsumen.list" });
        },

        errorValidation() {
            this.$v.payload.judul.$touch();
            this.$v.payload.iddevice.$touch();
            this.$v.payload.idtemplate.$touch();
            this.$v.payload.interval.$touch();
            this.$v.totalCustomer.$touch();
            this.$v.payload.idoutlet.$touch();
            return (
                this.$v.payload.judul.$invalid ||
                this.$v.payload.iddevice.$invalid ||
                this.$v.payload.idtemplate.$invalid ||
                this.$v.payload.idoutlet.$invalid ||
                this.$v.payload.interval.$invalid ||
                this.$v.totalCustomer.$invalid
            );
        },
        confirmBlast() {
            if (this.errorValidation()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }
            if (this.blastType !== null) {
                this.payload.jenis = this.blastType;
                this.payload.idjenis = this.blastTypeId;
            }
            this.setPayloadCreateBlast(this.payload);
            this.$router.push({ name: "wa_blast.create.confirm" });
        },
        async getOutlet() {
            try {
                const res = await this.$store.dispatch("outletModule/fetchOutletAll");
                this.listOutlet = res.data.map(value => {
                    return {
                        telp: value.telp,
                        id: value.idoutlet,
                        text: value.nama
                    }
                });
            } catch (error) {
                this.$toas.error(error)
            }
        },
        getJenis() {
            console.log(this.blastType);
            if (this.blastType !== null) {
                return
            }
            this.jenis = this.$route.query.jenis || null;
            this.idJenis = this.$route.query.idjenis || null;
            this.$store.commit(`${moduleName}/setBlastType`, this.jenis);
            this.$store.commit(`${moduleName}/setBlastTypeId`, this.idJenis);
        },
    },
};
</script>

<style scoped>
.wa-device-list-container {
    border-radius: 4px;
    border: 1px solid #c8d0dd;
}

.wa-device-selected {
    background: #edf5ff;
}
</style>
